import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GaTrackingEventCategory } from '~shared/modules/ga-tracking/constants';

export class OrderHistoryApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.OrderHistoryInteraction;

  constructor(private payload: {
    event: string,
    category?: string,
    action: string,
    label: string,
  }) {
  }

  getPayload(): any {
    const { event, category = GaTrackingEventCategory.Interaction, action, label } = this.payload;

    return {
      event,
      category,
      action,
      label,
    };
  }
}
